import type { DropDownOptionBase } from "../../../components/staff/DropDownMultiple";
import type {
  CustomFilterQueryClause,
  IFilterData,
} from "../../../components/Organismos/Table/FilteredTable.types";
import { CUSTOM_FILTER_CHIP_ID } from "../../../components/Organismos/Table/FilteredTable.types";
import { resolveAuditLogLocalRange } from "../../../utils/auditLogDateFilters";
import TemplateDateFlightsPicker from "../../SendEmail/TemplateDateFlightsPicker";
import { summarizeTemplateDateFilterSelection } from "../../SendEmail/templateDateFilter";
import {
  DEFAULT_TEMPLATE_DATE_FILTER,
  type TemplateDateFilterValue,
} from "../../../utils/templateDateFilterTypes";
import { STATUS_LABEL } from "./runLogDisplay";
import type { IntegratorRunStatus } from "../../../interfaces/models/IIntegratorRunLog";

const RUN_LOG_DATE_FILTER_NAME = "Run date";

const INTEGRATOR_RUN_STATUS_OPTIONS: DropDownOptionBase[] = (
  Object.keys(STATUS_LABEL) as IntegratorRunStatus[]
).map((id) => ({
  id,
  name: STATUS_LABEL[id],
}));

export function buildRunLogQueuedDateFilter(
  value: TemplateDateFilterValue
): CustomFilterQueryClause | null {
  const range = resolveAuditLogLocalRange(value);
  if (!range) {
    return null;
  }

  const startMs = new Date(
    range.from.getFullYear(),
    range.from.getMonth(),
    range.from.getDate(),
    0,
    0,
    0,
    0
  ).getTime();
  const endMs = new Date(
    range.to.getFullYear(),
    range.to.getMonth(),
    range.to.getDate(),
    23,
    59,
    59,
    999
  ).getTime();

  return {
    value: `${startMs} - ${endMs}`,
    comparisonType: "BETWEEN_TS",
  };
}

function runLogDateFilterChips(filterValue: unknown) {
  const label = summarizeTemplateDateFilterSelection(
    filterValue as TemplateDateFilterValue | null | undefined
  );
  if (!label) {
    return [];
  }
  return [{ id: CUSTOM_FILTER_CHIP_ID, name: label }];
}

function createRunLogDateFilterPanel(): IFilterData {
  return {
    name: RUN_LOG_DATE_FILTER_NAME,
    type: "custom",
    customTitle: RUN_LOG_DATE_FILTER_NAME,
    panelColSpan: "wide",
    defaultCustomFilterValue: DEFAULT_TEMPLATE_DATE_FILTER,
    customQueryFieldNames: ["queuedDate"],
    getCustomSelectedChips: runLogDateFilterChips,
    render: ({ value, apply }) => (
      <TemplateDateFlightsPicker
        value={
          (value as TemplateDateFilterValue | null | undefined) ??
          DEFAULT_TEMPLATE_DATE_FILTER
        }
        onApply={(next) => {
          const clause = buildRunLogQueuedDateFilter(next);
          apply(next, clause ? { queuedDate: clause } : null);
        }}
        variant="firmLogs"
        label="Run date:"
        dialogTitle="Run date"
        showYearPresets={false}
        hideLabel
      />
    ),
  };
}

export function buildIntegratorRunLogFiltersData(
  firmOptions: DropDownOptionBase[]
): IFilterData[] {
  return [
    {
      name: "Firm",
      fieldName: "firmId",
      type: "multiselect",
      objectData: firmOptions,
      comparison: "IN",
      sortByName: true,
    },
    {
      name: "Status",
      fieldName: "status",
      type: "multiselect",
      objectData: INTEGRATOR_RUN_STATUS_OPTIONS,
      comparison: "IN",
    },
    createRunLogDateFilterPanel(),
  ];
}
